import React from 'react';
import { OnboardingV2State } from '../../../store/onboardingV2/types.ts';
import { Question } from '../../../hooks/onboardingV2/useConversationalOnboarding.ts';
import { OnboardingStep } from '../../../utils/onboardingV2/conversationalOnboardingSteps.ts';
import AccountTypeSelector from './AccountTypeSelector/AccountTypeSelector.tsx';
import SkillsSelector from './SkillsSelector/SkillsSelector.tsx';
import ProfilesSelector from './ProfilesSelector/ProfilesSelector.tsx';
import WorkZonesSelector from './WorkZonesSelector/WorkZonesSelector.tsx';
import SummaryScreen from './SummaryScreen/SummaryScreen.tsx';
import CompleteActions from './CompleteActions/CompleteActions.tsx';

interface InteractiveComponentsProps {
  question: Question;
  state: OnboardingV2State;
  onAction: (action: string, data?: any) => void;
  setSelectedCategoryFilter?: (categoryId: number | null) => void;
  onNavigateToStep?: (step: OnboardingStep) => void;
}

const InteractiveComponents: React.FC<InteractiveComponentsProps> = ({
  question,
  state,
  onAction,
  setSelectedCategoryFilter,
  onNavigateToStep,
}) => {
  if (question.interactiveType === 'accountType') {
    return <AccountTypeSelector state={state} onAction={onAction} />;
  }

  if (question.interactiveType === 'skills') {
    return (
      <SkillsSelector
        state={state}
        onAction={onAction}
        setSelectedCategoryFilter={setSelectedCategoryFilter}
      />
    );
  }

  if (question.interactiveType === 'profiles') {
    return <ProfilesSelector state={state} onAction={onAction} />;
  }

  if (question.interactiveType === 'summary') {
    return <SummaryScreen state={state} onAction={onAction} />;
  }

  if (question.interactiveType === 'workZones') {
    return <WorkZonesSelector state={state} onAction={onAction} />;
  }

  if (question.interactiveType === 'completeActions') {
    return (
      <CompleteActions
        state={state}
        onAction={onAction}
        onNavigateToStep={onNavigateToStep}
      />
    );
  }

  return null;
};

export default InteractiveComponents;
